import React from "react";
import logo from "../../assets/images/aammi-logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Image1 from "../../assets/images/footer-donate-icon.png";
import Image2 from "../../assets/images/footer-fedback-icon.png";
import { Link, useLocation } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import Compareicon from "../../assets/images/compare_icon.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchFooterdetails } from "../../features/footerSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
const Footer = () => {
  const compareProductIds = useSelector(
    (state) => state.compare.compareProductIds || []
  );

  const dispatch = useDispatch();

  const { footerdetails, status, error } = useSelector(
    (state) => state.footerdetails
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchFooterdetails());
    }
  }, [dispatch, status]);
  const location = useLocation();
  const isComparePage = location.pathname === "/compare";
  const isCategoryPage = location.pathname.includes("/category/");
  const isSubCategoryPage = location.pathname.includes("/subcategory/");
  const isSubChildCategorypage =
    location.pathname.includes("/subchildcategory");
  const isArowclass =
    isCategoryPage || isSubCategoryPage || isSubChildCategorypage
      ? "categorypagearrowbtn"
      : "noncategorypagearrowbtn";
  const isComparebtn =
    isCategoryPage || isSubCategoryPage || isSubChildCategorypage
      ? "iscategorypagecomparebtn"
      : "noncategorypagecompare";
  return (
    <div className="Footer-bg footer_section pt-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="footer-brand-cont">
              <NavLink to="/">
                <img
                  src={logo}
                  className="footer-logo"
                  style={{ cursor: "pointer" }}
                />
              </NavLink>
              <div>
                <p>Get Latest Updates</p>
              </div>
              <div className="form">
                <input placeholder="Your email address" />
                <div className="arrow-bg">
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="social-icons">
              <p>Follow Our Social media</p>
              <div className="social-icon-bg">
                <a href={footerdetails.facebook_link} target="_blank">
                  {" "}
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
              </div>
              <div className="social-icon-bg">
                <a href={footerdetails.youtube_link} target="_blank">
                  {" "}
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
              <div className="social-icon-bg">
                <a href={footerdetails.instagram_link} target="_blank">
                  {" "}
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>

              <div className="social-icon-bg">
                <a href={footerdetails.twitter_link} target="_blank">
                  {" "}
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row second_row">
          <div className="col-lg-9 left_col">
            <div className="row">
              <div className="col-lg-3 col-md-6 grid_col">
                <h6>STORE LOCATION</h6>

                <p>
                  <Link>{footerdetails.address}</Link>
                </p>
              </div>
              <div className="col-lg-3 col-md-6 grid_col">
                <h6>CONNECTED WITH AAMMII</h6>
                <div>
                  <ul>
                    <li>
                      <Link to="">Events & Exhibition</Link>
                    </li>
                    <li>
                      <Link to="">How to make product</Link>
                    </li>
                    <li>
                      <Link to="">How to buy product</Link>
                    </li>
                    <li>
                      <Link to="">How to sell product</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 grid_col">
                <h6>ABOUT US</h6>
                <div>
                  <ul>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 grid_col">
                <h6>POLICIES</h6>
                <div>
                  <ul>
                    <li>
                      <Link to="/shipping-policy">Shipping Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-condition">Terms & Condition</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/product-damage-return-policy">
                        Product Damage / Return Policy
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 grid_col right_col">
            <h6>CUSTOMER SUPPORT</h6>
            <div>
              <ul>
                <li>
                  <a href={`tel:+60 ${footerdetails.mobile_number}`}>+60 {footerdetails.mobile_number}</a>
                </li>
                <li>
                  <a href={`tel:+60 ${footerdetails.alternative_mobile_number}`}>
                    +60 {footerdetails.alternative_mobile_number}
                  </a>
                </li>
                <li>
                  Email :&nbsp;
                  <a target="_blank" href={`mailto:${footerdetails.email_id}`}>
                    {footerdetails.email_id}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row third_row">
          <div className="col-lg-6 col-md-12 col-sm-12 left_col">
            <div className="inner-box">
              <span>
                <Link to="">Anatomic Therapy</Link>{" "}
              </span>
              <span className="horizontal_line">|</span>
              <span>
                {" "}
                <Link to="">Banu Home Education</Link>
              </span>
              <span className="horizontal_line">|</span>
              <span>
                {" "}
                <Link to="">Amaidhiyum Arokiammum </Link>
              </span>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 right_col">
            <div className="inner-box">
              <span>
                <img src={Image1} style={{ width: "10px" }} alt="img" />
                &nbsp;<Link to="">Donate</Link>
              </span>
              <span className="horizontal_line">|</span>
              <span>
                <img src={Image2} style={{ width: "10px" }} alt="img" />
                &nbsp; <Link to="">Feedback</Link>
              </span>
            </div>
          </div>
        </div>
        <div className="row fourth_row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <p>
              <span>© 2024 - 2025 </span>{" "}
              <span className="horizontal_line"> | </span>{" "}
              <span> Aammii All Rights Reserved </span>{" "}
              <span className="horizontal_line"> | </span>{" "}
              <span>
                {" "}
                <Link to="">Terms & Conditions</Link>
              </span>
            </p>
          </div>
        </div>
      </div>

      {!isComparePage && compareProductIds && compareProductIds.length > 0 && (
        <div className={`compare_component_main ${isComparebtn}`}>
          <div className="compare_component">
            <div className="compare_btn_box">
              <Link
                to="/compare"
                className="btn_1_1_1"
                style={{ textDecoration: "none" }}
              >
                <img
                  src={Compareicon}
                  style={{ display: "inline-block", width: "auto" }}
                  alt="img"
                />{" "}
                &nbsp;&nbsp;&nbsp;
                <div
                  style={{
                    backgroundColor: "#fff",
                    color: "#76a70e",
                    fontSize: "14px",
                    display: "inline-block",
                    height: "20px",
                    width: "20px",
                    textAlign: "center",
                  }}
                >
                  {compareProductIds.length}
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}

      <ScrollToTop smooth className={isArowclass} />
    </div>
  );
};

export default Footer;
